import { KIZEN_PREFIX, LocalStorage } from './Storage';

const WYSIWYG_COPY_KEY = `${KIZEN_PREFIX}wysiwyg-copy`;

export const wysiwygCopyLocalStorage = new LocalStorage(WYSIWYG_COPY_KEY);

const PI_CHAT_PANEL_WIDTH_KEY = `${KIZEN_PREFIX}pi-chat-panel-width`;

export const piChatPanelWidthLocalStorage = new LocalStorage<number>(
  PI_CHAT_PANEL_WIDTH_KEY
);
